import { SideBarContent } from '@/api/interfaces/content/app/sideBarContent';

export const sideBarContent: SideBarContent = {
    sideNavigationContent: {
        title: 'Menu',
    },
};
